import http from "@/shared/services/http";

export const statisticBillLading = (params: any) => http.get(`v1/customer/bill-ladings/dash-board`, { params });
export const statisticCod = (params: any) => http.get(`v1/customer/bill-ladings/statistic-cod`, { params });
export const statisticFee = (params: any) => http.get(`v1/customer/bill-ladings/statistic-fee`, { params });